import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Chip } from '@mui/material';
import { CustomChipDiffColor, FilterContainer, JobContainer, SidebarContainer } from './style';
import { PageHeader } from '../../../components/common/header/PageHeader';
import { JobDetails } from './cards/JobDetailCard';
import { TextSelect } from '@ui/components/common/inputs/TextSelect';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { filterVacancies, getVacancies } from '@application/features/vacancies/VacancyThunk';
export const Vacancies = () => {
    const { vacancies, areaOfExpertiseOptions, typeOfEmployement } = useAppSelector((state) => state.vacancy);
    const [selectedAreaOfExpertise, setSelectedAreaOfExpertise] = React.useState('');
    const [selectedHoursPerWeek, setSelectedHoursPerWeek] = React.useState('');
    const [selectedTypeOfEmployment, setSelectedTypeOfEmployment] = React.useState('');
    const [selectedWorkExperience, setSelectedWorkExperience] = React.useState('');
    const dispatch = useAppDispatch();
    const [chipsData, setChipsData] = useState([]);
    const hoursPerWeekOptions = [
        {
            label: 'Less than 20 hours',
            value: '<20'
        },
        {
            label: '20-40 hours',
            value: '20-40'
        }
    ];
    const workExperienceOptions = [
        {
            label: 'Entry-level (0-2)',
            value: '0-2'
        },
        {
            label: 'Mid-level (3-5)',
            value: '3-5'
        },
        {
            label: 'Senior-level (>5)',
            value: '6-100'
        }
    ];
    const handleAreaOfExpertiseChange = (value) => {
        setSelectedAreaOfExpertise(value);
        setChipsData((prevChips) => {
            const updatedChips = prevChips.filter((chip) => !areaOfExpertiseOptions.includes(chip.label));
            if (value) {
                updatedChips.push({ label: value });
            }
            return updatedChips;
        });
        applyFilters({
            ...getCurrentFilters(),
            FieldOfExpertise: value
        });
    };
    const getCurrentFilters = () => ({
        FieldOfExpertise: selectedAreaOfExpertise,
        HoursPerWeek: hoursPerWeekOptions.find((x) => x.label == selectedHoursPerWeek)?.value,
        EmploymentType: selectedTypeOfEmployment,
        WorkExperience: workExperienceOptions.find((x) => x.label == selectedWorkExperience)?.value
    });
    const applyFilters = (filters) => {
        dispatch(filterVacancies(filters));
    };
    const handleHoursPerWeekChange = (value) => {
        setSelectedHoursPerWeek(value);
        setChipsData((prevChips) => {
            const updatedChips = prevChips.filter((chip) => chip.label !== hoursPerWeekOptions.find((x) => x.label === selectedHoursPerWeek)?.label);
            const selectedHours = hoursPerWeekOptions.find((x) => x.label === value)?.label;
            if (selectedHours)
                updatedChips.push({ label: selectedHours });
            return updatedChips;
        });
        applyFilters({
            ...getCurrentFilters(),
            HoursPerWeek: hoursPerWeekOptions.find((x) => x.label == value)?.value
        });
    };
    const handleTypeOfEmploymentChange = (value) => {
        setSelectedTypeOfEmployment(value);
        setChipsData((prevChips) => {
            const updatedChips = prevChips.filter((chip) => chip.label !== selectedTypeOfEmployment);
            if (value)
                updatedChips.push({ label: value });
            return updatedChips;
        });
        applyFilters({
            ...getCurrentFilters(),
            EmploymentType: value
        });
    };
    const handleWorkExperienceChange = (value) => {
        setSelectedWorkExperience(value);
        setChipsData((prevChips) => {
            const updatedChips = prevChips.filter((chip) => chip.label !== workExperienceOptions.find((x) => x.label === selectedWorkExperience)?.label);
            const selectedExperience = workExperienceOptions.find((x) => x.label === value)?.label;
            if (selectedExperience)
                updatedChips.push({ label: selectedExperience });
            return updatedChips;
        });
        applyFilters({
            ...getCurrentFilters(),
            WorkExperience: workExperienceOptions.find((x) => x.label == value)?.value
        });
    };
    const handleDelete = (event) => {
        const chipElement = event.currentTarget.closest('.MuiChip-root');
        if (!chipElement)
            return;
        const chipLabel = chipElement.querySelector('.MuiChip-label')?.textContent;
        if (!chipLabel)
            return;
        setChipsData((prevChips) => prevChips.filter((chip) => chip.label !== chipLabel));
        if (hoursPerWeekOptions.some((option) => option.label === chipLabel)) {
            setSelectedHoursPerWeek('');
            applyFilters({
                ...getCurrentFilters(),
                HoursPerWeek: undefined
            });
        }
        else if (typeOfEmployement.includes(chipLabel)) {
            setSelectedTypeOfEmployment('');
            applyFilters({
                ...getCurrentFilters(),
                EmploymentType: undefined
            });
        }
        else if (workExperienceOptions.some((option) => option.label === chipLabel)) {
            setSelectedWorkExperience('');
            applyFilters({
                ...getCurrentFilters(),
                WorkExperience: undefined
            });
        }
        else if (areaOfExpertiseOptions.includes(chipLabel)) {
            setSelectedAreaOfExpertise('');
            applyFilters({
                ...getCurrentFilters(),
                FieldOfExpertise: undefined
            });
        }
    };
    useEffect(() => {
        dispatch(getVacancies());
    }, [dispatch]);
    return (_jsxs("div", { children: [_jsx(PageHeader, { title: 'Vacancies' }), _jsx(Box, { sx: { display: 'flex', justifyContent: 'flex-end' }, children: _jsx(Box, { sx: { width: { xs: '100%', md: '95%', lg: '95%', xl: '95%' } }, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, md: 2, xs: 12, xl: 2, lg: 2, sx: { display: { xs: 'none', md: 'block' } }, children: _jsxs(Box, { sx: { ...SidebarContainer, mt: 8, pr: 1 }, children: [_jsx(Typography, { variant: 'subtitle1', color: 'initial', children: "Filtered on" }), _jsx(Box, { mt: 5, sx: { ...SidebarContainer, gap: 1, width: '100%' }, children: chipsData.map((data, index) => (_jsx(Chip, { label: data.label, variant: 'outlined', onDelete: handleDelete, size: 'medium', sx: {
                                                    ...CustomChipDiffColor,
                                                    maxWidth: '100%',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    '& .MuiChip-deleteIcon': {
                                                        marginLeft: 1
                                                    }
                                                } }, index))) })] }) }), _jsxs(Grid, { item: true, md: 7, xl: 7, lg: 7, xs: 12, children: [_jsx(Box, { sx: {
                                            overflow: 'auto'
                                        }, children: _jsxs(Box, { sx: { ...FilterContainer, minWidth: 710 }, children: [_jsx(TextSelect, { color: 'white', options: areaOfExpertiseOptions?.map((a) => ({
                                                        label: a,
                                                        value: a
                                                    })), selectedOptions: selectedAreaOfExpertise, defaultOption: 'Field of expertise ', onSelect: handleAreaOfExpertiseChange }), _jsx(TextSelect, { color: 'white', options: hoursPerWeekOptions?.map((h) => ({
                                                        label: h.label,
                                                        value: h.value
                                                    })), selectedOptions: selectedHoursPerWeek, defaultOption: 'Hours per Week', onSelect: (selectedValue) => handleHoursPerWeekChange(selectedValue) }), _jsx(TextSelect, { color: 'white', options: typeOfEmployement?.map((t) => ({
                                                        label: t,
                                                        value: t
                                                    })), selectedOptions: selectedTypeOfEmployment, defaultOption: 'Type of Employment', onSelect: handleTypeOfEmploymentChange }), _jsx(TextSelect, { color: 'white', options: workExperienceOptions, selectedOptions: selectedWorkExperience, defaultOption: 'Work Experience', onSelect: handleWorkExperienceChange })] }) }), _jsx(Box, { sx: {
                                            ...JobContainer,
                                            mt: 2,
                                            height: 'calc(100svh - 290px)',
                                            overflow: 'auto'
                                        }, children: vacancies && vacancies.length > 0 ? (vacancies.map((item) => {
                                            return _jsx(JobDetails, { ...item, financials: item.financial, client: item.client });
                                        })) : (_jsx(Typography, { variant: 'h6', sx: {
                                                textAlign: 'center',
                                                marginTop: '20px'
                                            }, children: "No vacancies available" })) })] }), _jsx(Grid, { item: true, md: 3, sm: 12, xl: 3, lg: 3, xs: 12 })] }) }) })] }));
};
{
    /* <Box
sx={{
  overflow: "aut",
  background: "black",
  borderRadius: "25px",
}}
>     </Box> */
}
